<template>
  <div>
    <el-dialog
      width="32%"
      :title="`BPM审批单号：${bpmNum }`"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="status">
        <div class="status-list">
          <div v-for="(item, index) in bpmStatusList" :key="index">
            <div class="status-list__item"
              :class="{ 'status-list--active': item.status === '处理中' }"
            >
              <div class="status-list__info">
                <div class="status-list__step">
                  <div class="step-pointer"></div>
                  <div class="step-row" v-if="index !== bpmStatusList.length - 1" />
                </div>
                <div class="status-list__detail">
                  <div class="status-list__detail--user" style="margin-top: 3px">
                    {{ item.approvalUser }}
                  </div>
                  <div class="status-list__detail--user" style="margin: 6px 0">
                    {{ item.stepName }}
                  </div>
                  <div class="status-list__detail--time" v-if="item.status !== '处理中'">
                    {{ item.approvalTime }}
                  </div>
                </div>
              </div>
              <div class="status-list__name" style="margin-top: 3px">{{ item.status }}</div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'order-bpm',
  data () {
    return {
      dialogVisible: false,
      bpmStatusList: []
    }
  },
  computed: {
    bpmNum () {
      if (this.bpmStatusList.length) {
        return this.bpmStatusList[0].bpmNum
      }
      return ''
    }
  },
  created () {},
  methods: {
    async handleDialogShow (id) {
      const { data } = await this.$store.dispatch('getBpmStatusList', id)
      if (data.resultCode === '0') {
        this.bpmStatusList = data.resultData.bpmStepList || []
        this.bpmStatusList = this.bpmStatusList.reverse()
        this.bpmStatusList = this.bpmStatusList.filter((item) => {
          return item.status !== '未处理'
        })
        this.dialogVisible = true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.status-list {
  max-height: 370px;
  overflow-y: auto;
  box-sizing: border-box;
  font-size: 14px;
  color: $base-green;
  &__info {
    display: flex;
  }
  &__item {
    display: flex;
    justify-content: space-between;
    height: 90px;
  }
  &__name {
    color: $base-green;
  }

  &__step {
    width: 20px;
    .step-pointer {
      width: 20px;
      height: 20px;
      border-radius: 20px;
      background-color: $base-green;
    }
    .step-row {
      width: 2px;
      height: 70px;
      margin: auto;
      background-color: #ccc;
    }
  }
  &__detail {
    margin-left: 16px;
    &--time {
      font-size: 12px;
    }
  }

  &--active {
    color: $base-red;
    .status-list__name {
      color: $base-red;
    }
    .step-pointer {
      background-color: $base-red;
    }
  }
}

.popup-btn {
  display: flex;
  justify-content: space-around;
  padding: 15px;

  &__confirm {
    width: 75px;
    height: 32px;
    line-height: 32px;
    border-radius: 5px;
    font-size: 14px;
    text-align: center;
    color: #fff;
    background-color: $base-red;
  }
}
</style>
